import React from 'react';
import { convertRichTextToPlainText } from '../shared/utils';

export interface StructuredSchemaDataProps {
    staticItems?: StructuredSchemaFaqItem[] | StructuredSchemaItem[]
    queryItems?: Queries.ContentfulPageContentQuery['pageData']['structuredSchemaData']
}

export type StructuredSchemaItem = {
    itemType: 'ContentfulStructuredSchemaFaqItem' | string
}

export type StructuredSchemaFaqItem = StructuredSchemaItem & {
    questionText: string
    answerText: string
}

const toStructuredSchemaItems = (items: Queries.ContentfulPageContentQuery['pageData']['structuredSchemaData']): (StructuredSchemaFaqItem | StructuredSchemaItem)[] => {
    return items.map((item) => {
        if (item.itemType === 'ContentfulStructuredSchemaFaqItem') {
            return {
                itemType: 'ContentfulStructuredSchemaFaqItem',
                questionText: item.questionText,
                answerText: convertRichTextToPlainText(JSON.parse(item.answerText.raw))
            } as StructuredSchemaFaqItem
        }
        return {
            itemType: item.itemType,
            questionText: undefined,
            answerText: undefined
        } as StructuredSchemaItem
    }).filter(Boolean)
}

const sanitizeText = (text: string) => {
    if (!text) return '';
    // return JSON.stringify(text.replace(/\r/g, '').replace(/\n/g, ''));
    return JSON.stringify(text);
}

export const StructuredSchemaData = ({ staticItems, queryItems }: StructuredSchemaDataProps) => {
    const parsedItems = [...(staticItems || []), ...(queryItems ? toStructuredSchemaItems(queryItems) : [])];
    if (!parsedItems || parsedItems.length === 0) return <></>;

    const faqs = parsedItems.filter(e => e.itemType === 'ContentfulStructuredSchemaFaqItem') as StructuredSchemaFaqItem[];

    return (
        <>
            {faqs.length > 0 && (
                <script type="application/ld+json" id="schema-faq" key="schema-faq">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                    ${faqs.map((item) => {
                        return `
                                {
                                    "@type": "Question",
                                    "name": ${sanitizeText(item.questionText)},
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": ${sanitizeText(item.answerText)}
                                    }
                                }
                                `
                    })}
                        ]
                    }
                    `}
                </script>
            )}
        </>
    )
}